import React, { useEffect } from "react";
import Pharmacycon from "./Pharmacycon";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Pharmacy() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Pharmacycon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Pharmacy Store in Whitefield</title>
        <meta
          name="description"
          content="We are the best pharmacy store in Whitefield and have all kinds of medicines. Feel free to visit us today."
        />
        <meta
          name="keywords"
          content="Best pharmacy store in Whitefield, Best pharmacy store in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestpharmacyservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestpharmacyservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers pharmacy services with prescription dispensing, over-the-counter medicines, medication guidance, and healthcare product support.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Prescription medicine dispensing",
              "Over-the-counter medications",
              "Medication counselling and guidance",
              "Refill and dosage support",
              "Health supplements and wellness products",
              "Basic healthcare devices and supplies",
            ],
            keywords: [
              "Best Pharmacy services in Immadihalli",
              "Best Pharmacy services in Whitefield",
              "Best Pharmacy services in Bangalore",
              "Best Pharmacy services in Kundalahalli",
              "Best Pharmacy services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>
      <h2 style={{ display: "none" }}>
        Best pharmacy store in Whitefield aspect of your pharmaceutical
        experience. Looking for the best pharmacy store in Whitefield? Then you
        are at the right place. Visit us today.
      </h2>

      <Servicebanner name="Pharmacy" banner={"../photo/dd18.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
                <Divider />
              </div>
              <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Pharmacy;
